module.exports = __webpack_public_path__ + "img/smoke_banner.48601815.png";